<template>
  <v-card style="background: #fff !important">
    <v-card-title>
      稼働日管理
      <v-spacer />
      <!-- <v-btn @click="edit()">更新</v-btn> -->
    </v-card-title>
    <v-card-title>
      <v-btn @click="lastMonth" flat icon>
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <v-spacer />
      <h1>{{ currentMonthStr }}</h1>
      <v-spacer />
      <v-btn @click="nextMonth" flat icon>
        <v-icon>keyboard_arrow_right</v-icon>
      </v-btn>
    </v-card-title>
    <table>
      <tr>
        <th :key="week" v-for="week in $t('app.weekdays')">{{ week }}</th>
      </tr>
      <tr :key="i" v-for="(w, i) in weeks">
        <td
          v-show="d.isLastMonth || d.isCurrentMonth || d.isNextMonth"
          :class="{
            disable: !d.isCurrentMonth,
            today:
              d.date.setHours(0, 0, 0, 0) === new Date().setHours(0, 0, 0, 0),
          }"
          :key="i"
          style="text-align: center"
          v-for="(d, i) in days.slice(i * 7, i * 7 + 7)"
          v-ripple
          @click="changeCalendarType(currentDate(d.date), d.isCurrentMonth)"
        >
          <div
            :class="{
              date,
              disabledDate: d.isCurrentMonth && work(d.date) === 'HOLIDAY',
            }"
          >
            <span v-if="d.isCurrentMonth" class="day">{{
              d.date.getDate()
            }}</span>
            <span v-if="d.isCurrentMonth" class="work">{{
              work(d.date) === 'HOLIDAY' ? '休' : '稼'
            }}</span>
          </div>
        </td>
      </tr>
    </table>
  </v-card>
</template>

<script>
import DateFormat from 'dateformat'
import { Ripple } from 'vuetify/es5/directives'
export default {
  components: {},
  directives: { Ripple },
  props: ['value', 'type'],
  data() {
    return {
      date: new Date(),
      year: null,
      month: null,
      pickerDate: null,
      items: {},
    }
  },
  created() {
    this.year = this.date.getFullYear()
    this.month = this.date.getMonth()
  },
  computed: {
    currentMonthStr() {
      return DateFormat(new Date(this.year, this.month, 1), 'yyyy-mm')
    },
    firstDate() {
      return new Date(this.year, this.month, 1)
    },
    lastDate() {
      return new Date(this.year, this.month + 1, 0)
    },
    test() {
      return this.lastDate.getDay()
    },
    days() {
      let result = []
      let firstDay = this.firstDate.getDay()
      for (let p = 0; p < firstDay; p++) {
        result.push({
          date: new Date(this.year, this.month, -firstDay + p + 1),
          isLastMonth: true,
        })
      }
      for (let d = 0; d < this.lastDate.getDate(); d++) {
        result.push({
          date: new Date(this.year, this.month, d + 1),
          isCurrentMonth: true,
        })
      }
      let lastDay = 42 - result.length
      for (let i = 0; i < lastDay; i++) {
        result.push({
          date: new Date(this.year, this.month + 1, i + 1),
          isNextMonth: true,
        })
      }
      return result
    },
    weeks() {
      if (this.days.filter((d) => d.isNextMonth).length >= 7) {
        return Math.floor(
          (this.days.filter((d) => d.isCurrentMonth).length + 6) / 7
        )
      }
      return Math.ceil(
        (this.days.filter((d) => d.isCurrentMonth).length + 6) / 7
      )
    },
  },
  watch: {
    value() {
      this.load()
    },
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.$http.get(`calendar?type=${this.type}`).then((res) => {
        this.items = res.data.reduce((i, s) => {
          i[s.date] = s.calendarType
          return i
        }, {})
      })
    },
    lastMonth() {
      if (this.month === 0) {
        this.year = this.year - 1
        this.month = 11
      } else {
        this.month = this.month - 1
      }
    },
    nextMonth() {
      if (this.month === 11) {
        this.year = this.year + 1
        this.month = 0
      } else {
        this.month = this.month + 1
      }
    },
    currentDate(date) {
      return DateFormat(date, 'yyyy-mm-dd')
    },
    work(date) {
      const item = this.items[DateFormat(date, 'yyyy-mm-dd')]
      return item
    },
    changeCalendarType(date, currentMonth) {
      if (currentMonth) {
        this.$http
          .put(`/calendar/${date}/change-type?type=${this.type}`)
          .then(() => {
            this.load()
          })
          .catch(() => {
            this.$message('', 'Error')
          })
      }
    },
  },
}
</script>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
}

tr {
  border-bottom: 1px solid #ccc;
}
td {
  border: 1px solid #f0f0f0;
  height: 80px;
  width: 14.286%;
  box-sizing: border-box;
  cursor: pointer;
  position: relative;
}

td.disable {
  color: white;
  background-color: white;
}
.date .limit {
  font-size: 16px;
}
.date .day {
  position: absolute;
  right: 3px;
  top: 3px;
}
.date .work {
  position: absolute;
  right: 3px;
  bottom: 3px;
  font-size: 9px;
}
td.today {
  background: #fffde7;
}
.date {
  height: 100%;
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.disabledDate {
  color: black;
  background-color: #ddd;
}
</style>
